import { WithRef } from '../../../types';
import IconBase, { CastProductIconProps, getStrokeWidth } from '../IconBase';

const DEFAULT_PRESET_BACKGROUND = '#8EE0B0';

export const CastCostOptimization = ({
  ref,
  variant,
  color = 'currentColor',
  ...props
}: WithRef<SVGSVGElement, CastProductIconProps>) => {
  const strokeWidth = props.strokeWidth ?? getStrokeWidth(props.weight);
  const isPreset = variant === 'preset';
  const fill = isPreset
    ? props.fill ?? DEFAULT_PRESET_BACKGROUND
    : props.fill ?? 'none';

  return (
    <IconBase
      ref={ref}
      {...props}
      color={color}
      fill="none"
      viewBox="0 0 28 31"
    >
      <path
        d="M27.7581 21.377V9.74799C27.7581 8.47798 27.0806 7.30189 25.9783 6.66689L15.9077 0.851251C14.8077 0.21625 13.4505 0.21625 12.3504 0.851251L2.27979 6.66689C1.17972 7.30189 0.5 8.47798 0.5 9.74799V21.377C0.5 22.647 1.17748 23.8231 2.27979 24.4581L12.3504 30.2737C13.4505 30.9088 14.8077 30.9088 15.9077 30.2737L25.9783 24.4581C27.0784 23.8231 27.7581 22.647 27.7581 21.377Z"
        fill={fill}
      />
      <mask
        id="mask0_4268_2715"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="31"
      >
        <path
          d="M27.7581 21.377V9.74799C27.7581 8.47798 27.0806 7.30189 25.9783 6.66689L15.9077 0.851251C14.8077 0.21625 13.4505 0.21625 12.3504 0.851251L2.27979 6.66689C1.17972 7.30189 0.5 8.47798 0.5 9.74799V21.377C0.5 22.647 1.17748 23.8231 2.27979 24.4581L12.3504 30.2737C13.4505 30.9088 14.8077 30.9088 15.9077 30.2737L25.9783 24.4581C27.0784 23.8231 27.7581 22.647 27.7581 21.377Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask0_4268_2715)">
        <path
          d="M15.125 13.875L3.875 26.25"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
        <path
          d="M9.17656 24.0211C11.4794 25.5398 13.5455 25.6087 14.4922 25.5398C19.7129 25.1602 23.4016 21.4073 23.4016 16.3258C23.4016 11.2444 19.2823 7.125 14.2008 7.125C9.11935 7.125 5 11.2444 5 16.3258C5 17.6886 5.47461 20.7937 7.37305 22.3125"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
        <path
          d="M15.6618 25.3898V14.0303L5.26465 14.0736"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
      </g>
    </IconBase>
  );
};

CastCostOptimization.displayName = 'CastCostOptimization';
